"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _Input = _interopRequireDefault(require("../../../Input"));

var _pad = _interopRequireDefault(require("../../../../utils/pad"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _colors = _interopRequireDefault(require("../../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../../constants/vars"));

var _limitAround = _interopRequireDefault(require("../../utils/limitAround"));

var _roundToMultiple = _interopRequireDefault(require("../../utils/roundToMultiple"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-color: ", " !important;\n\twidth: ", " !important;\n\tpadding: 0px !important;\n\tfont-size: ", ";\n\tfont-family: ", " !important;\n\ttext-align: center;\n\t:focus {\n\t\tbackground-color: ", ";\n\t}\n\t&&::-webkit-outer-spin-button,\n\t::-webkit-inner-spin-button {\n\t\t-webkit-appearance: none;\n\t\tmargin: 0;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: -", " 0 -", " 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var InputContainer = _styledComponents.default.div(_templateObject(), _spacing.default.s1, _spacing.default.s1);

InputContainer.displayName = 'InputContainer';
var InputField = (0, _styledComponents.default)(_Input.default)(_templateObject2(), _colors.default.white, function (props) {
  return props.paddingLen < 4 ? _spacing.default.s11 : _spacing.default.s14;
}, _spacing.default.s5, _vars.default.fontStackNormal, _colors.default.bodyBackground);
InputField.displayName = 'InputField';

var TimeInput =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TimeInput, _React$Component);

  function TimeInput(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      valueBeingTypedIn: null
    };
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = TimeInput.prototype;

  _proto.setNewValue = function setNewValue(shouldApply) {
    if (shouldApply === void 0) {
      shouldApply = false;
    }

    var _this$props = this.props,
        steps = _this$props.steps,
        min = _this$props.min,
        max = _this$props.max,
        setTime = _this$props.setTime;
    var valueBeingTypedIn = this.state.valueBeingTypedIn;
    if (!valueBeingTypedIn) return;
    var rawValue = parseInt(valueBeingTypedIn, 10);
    var newValue = (0, _limitAround.default)(rawValue, min, max);
    newValue = (0, _roundToMultiple.default)(newValue, steps);

    if (newValue > max) {
      newValue = max + 1 - steps;
    }

    this.setState({
      valueBeingTypedIn: null
    });
    setTime(newValue, shouldApply);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        steps = _this$props2.steps,
        value = _this$props2.value,
        paddingLen = _this$props2.paddingLen,
        unit = _this$props2.unit;
    var valueBeingTypedIn = this.state.valueBeingTypedIn;
    return _react.default.createElement(InputContainer, null, _react.default.createElement(InputField, {
      value: valueBeingTypedIn != null ? valueBeingTypedIn : (0, _pad.default)(value, paddingLen),
      paddingLen: paddingLen,
      type: "number",
      step: steps,
      onChange: function onChange(e) {
        _this2.setState({
          valueBeingTypedIn: e.target.value
        });
      },
      ref: function ref(c) {
        _this2.props.setRef(c);
      },
      onInput: this.props.hasUserEnteredInputManually,
      onBlur: function onBlur() {
        _this2.setNewValue();
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          e.preventDefault();

          _this2.setNewValue(true);
        }
      },
      "data-e2e": "time-" + unit
    }));
  };

  return TimeInput;
}(_react.default.Component);

TimeInput.displayName = 'TimeInput';
TimeInput.propTypes = {
  hasUserEnteredInputManually: _propTypes.func.isRequired,
  steps: _propTypes.number.isRequired,
  min: _propTypes.number.isRequired,
  max: _propTypes.number.isRequired,
  setTime: _propTypes.func.isRequired,
  value: _propTypes.number.isRequired,
  paddingLen: _propTypes.number.isRequired,
  setRef: _propTypes.func.isRequired,
  unit: _propTypes.string
};
TimeInput.defaultProps = {
  unit: ''
};
var _default = TimeInput;
exports.default = _default;